package com.downdogapp.client.views.playback

import com.downdogapp.*
import com.downdogapp.Display.FLEX
import com.downdogapp.FlexDirection.ROW
import com.downdogapp.Size.Companion.px
import com.downdogapp.client.AbstractView
import com.downdogapp.client.View
import com.downdogapp.client.resources.Images
import com.downdogapp.client.widget.imageButton
import org.w3c.dom.HTMLDivElement
import org.w3c.dom.HTMLElement
import org.w3c.dom.HTMLImageElement

actual class SongAttributionView : AbstractView(), View {

  private var songTitleArtist: HTMLElement
  private var skipButton: HTMLImageElement
  private lateinit var onSkipClicked: () -> Unit

  override val root = createDiv {
    display = FLEX
    flexDirection = ROW
    alignItems = AlignItems.CENTER
    justifyContent = JustifyContent.FLEX_END

    songTitleArtist = label(fontSize = 18, fontWeight = FontWeight.MEDIUM)

    skipButton = imageButton(Images.SKIP_ICON_PADDED, clickFn = { onSkipClicked() }) {
      marginLeft = px(5)
    }
  }

  actual fun onSkipClicked(callback: () -> Unit) {
    this.onSkipClicked = callback
  }

  private fun hideContent() {
    songTitleArtist.hide()
    skipButton.hide()
  }

  private fun showContent() {
    songTitleArtist.show()
    skipButton.show()
  }

  actual fun setText(text: String?) {
    songTitleArtist.textContent = text ?: ""
    if (text != null) {
      showContent()
    } else {
      hideContent()
    }
  }
}

fun HTMLElement.songAttributionView(init: HTMLDivElement.() -> Unit = {}): SongAttributionView {
  val view = SongAttributionView()
  append(view.root)
  view.root.apply(init)
  return view
}
